import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CatalogsComponent } from './catalogs.component';
import { CreateServiciosComponent } from './create-servicios/create-servicios.component';
import { BandejatramitesComponent } from './bandejatramites/bandejatramites.component';
import { CreateTramitesComponent } from './create-tramites/create-tramites.component';
import { VerTramiteComponent } from './ver-tramite/ver-tramite.component';
import { ShowTramiteComponent } from './show-tramite/show-tramite.component';
import { ConsultaCatalogoComponent } from './consulta-catalogo/consulta-catalogo.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'ver_ficha/:id',
        component: ShowTramiteComponent,
        data: {
          title: 'Ver Trámite',
        }
      },
      {
        path: 'ver-tramite/:id',
        component: VerTramiteComponent,
        data: {
          title: 'Ver Trámite',
        }
      },
      {
        path: 'create-tramites',
        component: CreateTramitesComponent,
        data: {
          title: 'Crear Trámite',
        }
      },
      {
        path: 'areas',
        component: CatalogsComponent,
        data: {
          title: "Áreas",
          breadcrumb: "Áreas"
        }
      },
      {
        path: 'dependencias',
        component: CatalogsComponent,
        data: {
          title: "Dependencias",
          breadcrumb: "Dependencias"
        }
      },
      {
        path: 'services',
        component: CatalogsComponent,
        data: {
          title: "Servicios",
          breadcrumb: "Servicios"
        }
      },
      {
        path: 'create-tramite',
        component: CreateTramitesComponent,
        data: {
          title: 'Crear Ficha de Trámite',
        }
      },
      {
        path: 'sources',
        component: CatalogsComponent,
        data: {
          title: "Fuentes",
          breadcrumb: "Fuentes"
        }
      },
      {
        path: 'users',
        component: CatalogsComponent,
        data: {
          title: "Perfiles",
          breadcrumb: "Perfiles"
        }
      },
      {
        path: 'tipos-documento',
        component: CatalogsComponent,
        data: {
          title: "Tipos de documento",
          breadcrumb: "Tipos de documento"
        }
      },
      {
        path: 'reportes',
        component: CatalogsComponent,
        data: {
          title: "Tipos de Reporte",
          breadcrumb: "Tipos de Reporte"
        }
      },
      {
        path: 'bandeja',
        component: BandejatramitesComponent,
        data: {
          title: "Bandeja de Trámites",
          breadcrumb: "Bandeja de Trámites",
        }
      },
      {
        path: 'consulta-catalogo',
        component: ConsultaCatalogoComponent,
        data: {
          title: "Consulta de Catálogo de Trámites",
          breadcrumb: "Consulta de Catálogo de Trámites",
        }
      },
      {
        path: 'codigos-scian',
        component: CatalogsComponent,
        data: {
          title: "Códigos SCIAN",
          breadcrumb: "Códigos SCIAN",
        }
      },
      {
        path: 'turnos',
        component: CatalogsComponent,
        data: {
          title: "Turnos",
          breadcrumb: "Turnos",
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CatalogsRoutingModule { }
